// extracted by mini-css-extract-plugin
module.exports = {"modal":"MobileNavigationBar_modal__2XPgu","slide":"MobileNavigationBar_slide__1_5uv","modalOverlay":"MobileNavigationBar_modalOverlay__2VDSn"};